@if (isChangelogVisible) {
<div class="about">
  <div *ngIf="changelogContent | async as content" class="changelog-content">
    <div [innerHTML]="content"></div>
  </div>
  <button id="closeAboutBtn" class="closeBtn" (click)="closeChangelog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
} @else {
<div class="about">
  <button id="closeAboutBtn" class="closeBtn" (click)="closeAbout()">
    <mat-icon>close</mat-icon>
  </button>
  <h5>
    {{ applicationSettings?.option?.appInfo?.title?.[lang] || selText.title || applicationSettings.application }}
    </h5>
    @if (applicationSettings?.option?.mapviewVersion) {
    <p class="aboutTxt">
      {{ selText.appVersion }}: {{ applicationSettings.option.mapviewVersion }}
    </p>
    }
  @if (applicationSettings?.option?.appInfo?.info?.[lang]) {
  <p class="aboutTxt" [innerHTML]="applicationSettings?.option?.appInfo?.info?.[lang]"></p>
  }
  @if (applicationSettings?.option?.appInfo?.compactAbout) {
  <div class="aboutTxt compactAboutLinks">
    @if (applicationSettings?.option?.appInfo?.cookies?.[lang]) {
    <span class="compactAboutItem" [innerHTML]="applicationSettings?.option?.appInfo?.cookies?.[lang]"></span>
    } @else if (selText.cookiePolicy) {
    <button class="btnText compactAboutItem" (click)="showCookiePolicy = !showCookiePolicy">
      {{ selText.cookiePolicy }}
    </button>
    }

    @if (applicationSettings?.option?.appInfo?.instructions?.[lang]) {
    <span class="compactAboutItem" [innerHTML]="applicationSettings?.option?.appInfo?.instructions?.[lang]"></span>
    } @else if (selText.userguide && selText.userguide_mapview_url) {
    <a class="compactAboutItem" href={{selText.userguide_mapview_url}} target="_blank">{{ selText.userguide }}</a>
    }

    @if (applicationSettings?.option?.appInfo?.laws?.[lang]) {
    <span class="compactAboutItem" [innerHTML]="applicationSettings?.option?.appInfo?.laws?.[lang]"></span>
    } @else if (selText.regulation && selText.laws_and_regulations_url) {
    <a class="compactAboutItem" href={{selText.laws_and_regulations_url}} target="_blank">{{ selText.regulation }}</a>
    }
    
    @if (selText.releaseNotes) {
    <a (click)="openChangelog()" class="btnText compactAboutItem">{{ selText.releaseNotes }}</a>
    }
    </div>
    @if (!applicationSettings?.option?.appInfo?.cookies?.[lang] && showCookiePolicy) {
    <div>
      <p class="aboutTxt">
      {{ selText.cookiePolicyText }}<br /><a href={{selText.cookie_info_url}} target="_blank">{{ selText.more }}</a>
      </p>
  </div>
  }
  } @else {
  @if (applicationSettings?.option?.appInfo?.cookies?.[lang]) {
  <p class="aboutTxt aboutLinkRow" [innerHTML]="applicationSettings?.option?.appInfo?.cookies?.[lang]"></p>
  } @else {
  <p class="aboutTxt aboutLinkRow">
    <button class="btnText" (click)="showCookiePolicy = !showCookiePolicy">
      {{ selText.cookiePolicy }}
    </button>
  </p>
  @if (showCookiePolicy) {
  <div>
    <p class="aboutTxt">
      {{ selText.cookiePolicyText }}<br /><a href={{selText.cookie_info_url}} target="_blank">{{ selText.more }}</a>
    </p>
  </div>
  }
  }
  @if (applicationSettings?.option?.appInfo?.instructions?.[lang]) {
  <p class="aboutTxt aboutLinkRow" [innerHTML]="applicationSettings?.option?.appInfo?.instructions?.[lang]"></p>
  } @else {
  <p class="aboutTxt aboutLinkRow">
    <a href={{selText.userguide_mapview_url}} target="_blank">{{ selText.userguide }}</a>
  </p>
  }
  @if (applicationSettings?.option?.appInfo?.laws?.[lang]) {
  <p class="aboutTxt aboutLinkRow" [innerHTML]="applicationSettings?.option?.appInfo?.laws?.[lang]"></p>
  } @else {
  <p class="aboutTxt aboutLinkRow">
    <a href={{selText.laws_and_regulations_url}} target="_blank">{{ selText.regulation }}</a>
  </p>
  }
  <div>
    <p class="aboutTxt aboutLinkRow">
      <a (click)="openChangelog()" class="btnText">{{ selText.releaseNotes }}</a>
      </p>
  </div>
  }
  <p class="aboutTxt versionTxt">
    {{ selText.frontendVersion }} {{ frontendVersionNumber }}<br>
    {{ selText.backendVersion }} {{ backendVersionNumber }}
  </p>
  @if (applicationSettings?.option?.appInfo?.copyright?.[lang]) {
  <p class="aboutTxt copyright">
    @for (line of applicationSettings.option.appInfo.copyright[lang].split('\n'); track line; let last = $last) {<span>{{
      line }} {{ currentYear }}</span>@if (!last) {<br>}}
    </p>
    } @else {
    @if (ownerTitle) {
    <p class="aboutTxt copyright">
      <mat-icon>copyright</mat-icon> {{ ownerTitle }} {{ currentYear }}
    </p>
    }
    }
  <footer>
    @if (authGroupInfo?.group?.option?.link) {
    <a href="{{ authGroupInfo.group.option.link }}" target="_blank" matTooltip="{{ ownerTitle }}"
      matTooltipClass="tooltipStyle" aria-label="Homepage">
      <mat-icon>link</mat-icon>
    </a>
    }
    @if (authGroupInfo?.group?.option?.email) {
    <a href="mailto:{{ authGroupInfo.group.option.email }}" target="_blank" rel="noopener noreferrer"
      matTooltip="{{ selText.contactUsText }}" matTooltipClass="tooltipStyle" aria-label="Email">
      <mat-icon>email</mat-icon>
    </a>
    }
    @if (authGroupInfo?.group?.option?.facebook) {
    <a href="{{ authGroupInfo.group.option.facebook }}" target="_blank" matTooltip="{{ selText.socialMedia }}"
      matTooltipClass="tooltipStyle" aria-label="Facebook">
      <mat-icon>facebook</mat-icon>
    </a>
    }
  </footer>
  </div>
}